"use client";

import { Button } from "@/components/ui/button";
import * as Sentry from "@sentry/nextjs";
import {
  ArrowLeftIcon,
  HomeIcon,
  RefreshCwIcon,
  TriangleAlertIcon,
} from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const router = useRouter();

  return (
    <div className=" flex items-center justify-center min-h-screen">
      <div className="max-w-md w-full bg-card rounded-xl shadow-lg p-8 flex flex-col items-center">
        <div className="mb-4">
          <TriangleAlertIcon className="size-12 text-yellow-500" />
        </div>
        <h1 className="text-2xl font-bold text-primary mb-2">
          Ocorreu um erro inesperado
        </h1>
        <p className="text-gray-600 text-center mb-4">
          Não foi possível processar sua solicitação.
          <br />
          Tente novamente ou volte para a página inicial.
        </p>
        <Button
          variant="outline"
          className="w-full mb-2"
          onClick={() => router.refresh()}
        >
          <RefreshCwIcon className="mr-2" /> Tentar novamente
        </Button>
        <Button asChild>
          <Link href="/" className="w-full mb-2">
            <HomeIcon className="mr-2" /> Voltar para início
          </Link>
        </Button>
        <Button
          onClick={() => router.back()}
          variant="secondary"
          className="w-full"
        >
          <ArrowLeftIcon className="mr-2" /> Voltar
        </Button>
        <div className="mt-6 text-xs text-gray-400">
          {error?.digest && <span>Código de referência: {error.digest}</span>}
        </div>
      </div>
    </div>
  );
}
